import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from '@blueprint/ui';
import { Text } from '@blueprint/text';

export const SummaryHeaderWrapper = styled('div')(
    ({ theme: { spacing } }) => css`
        margin-top: ${spacing['16px']};
        margin-bottom: ${spacing['16px']};
    `
);

export const HeaderContainer = styled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;
        margin-bottom: ${spacing['24px']};
    `
);

export const ResponsiveHeaderContainer = styled('div')(
    ({ theme: { mq, spacing } }) => css`
        display: flex;
        flex-direction: column;

        ${mq.medium} {
            flex-direction: row;
        }

        ${HeaderLeftColumn} {
            margin-bottom: ${spacing['24px']};
            ${mq.medium} {
                margin-bottom: ${spacing['16px']};
            }
        }

        ${HeaderLeftColumn}, ${HeaderRightColumn} {
            width: 100%;

            ${mq.medium} {
                margin-bottom: 0;
                width: 50%;
                ${LinkStyleButton} {
                    float: right;
                }
            }
        }
    `
);

export const HeaderLeftColumn = styled('div')(
    () => css`
        width: 50%;
    `
);

export const HeaderRightColumn = styled('div')(
    () => css`
        text-align: right;
        width: 50%;
    `
);

export const ImageWrapper = styled(Text)(
    ({ theme: { spacing, mq } }) => css`
        padding-top: ${spacing['8px']};

        ${mq.medium} {
            padding-top: ${spacing['16px']};
        }

        img {
            min-height: 51px;
            min-weight: 139px;
        }
    `
);

export const LinkStyleButton = styled(Link)(
    ({ theme: { mq, type, spacing } }) => css`
        display: flex;
        align-items: center;
        font-size: ${type.body};

        svg {
            margin-left: ${spacing['8px']};
        }

        ${mq.large} {
            display: inline-flex;
            order: 0;
            white-space: pre;
        }
    `
);
